import './index.less';

export default () => {
    return (
        <div className="not-found-container">
            <img src="/images/notFound.svg"></img>
            <div>找不到资源</div>
        </div>
    );
};
